import client from '@/clients/customer/api-client';

export const logOut = () => client.post('/logout');

export const accountDeleteRequest = () => client.delete('/profile');

export const sendPhoneOtp = (data: { phone: string }, headers = {}) =>
  client.post('/phone/send-otp', data, { headers });

export const verifyPhoneOtp = (
  data: { phone: string; otp: string },
  headers = {}
) => client.post('/phone/verify', data, { headers });
